import React from 'react';
import styled from 'styled-components';

import { media } from '~/static/styles/mixins';
import SignupEmailPage from '../SignupEmailPage';

const Wrap = styled.div<{ gutterBottom?: boolean; gutterTop?: boolean }>`
	width: 100%;
	display: flex;
	justify-content: center;
	margin-top: ${({ gutterTop }) => (gutterTop ? '38px' : '0')};
	margin-bottom: ${({ gutterBottom }) => (gutterBottom ? '16px' : '0')};

	${media.large`
		display: none;
	`}
`;

const MobileLandingSignup = ({
	gutterBottom,
	gutterTop,
}: {
	gutterBottom?: boolean;
	gutterTop?: boolean;
}) => {
	return (
		<Wrap gutterBottom={gutterBottom} gutterTop={gutterTop}>
			<SignupEmailPage isLandingPage />
		</Wrap>
	);
};

export default MobileLandingSignup;
